import { requiresAuth } from '@martyrs/src/modules/auth/views/middlewares/auth.validation.js';

export function getPaymentsRoutes(options = {}) {
  const route = options.route || 'User Profile Root';

  return {
    parentName: route,
    config: {
      basePath: 'payments',
      meta: {
        title: { ru: 'Платежи', en: 'Payments' },
      },
      routes: [
        {
          path: '',
          name: 'PaymentHistory',
          beforeEnter: [requiresAuth],
          meta: { title: { ru: 'История платежей', en: 'Payment History' } },
          component: () => import('../components/pages/PaymentHistory.vue'),
        },
        {
          path: 'subscriptions',
          name: 'Subscriptions',
          beforeEnter: [requiresAuth],
          meta: { title: { ru: 'Подписки', en: 'Subscriptions' } },
          component: () => import('../components/pages/Subscriptions.vue'),
        },
        {
          path: 'plans',
          name: 'Plans',
          meta: { title: { ru: 'Тарифы', en: 'Plans' } },
          component: () => import('../components/pages/Plans.vue'),
        },
      ],
    },
  };
}
